import React from 'react';
export default function GroupTitle(_a) {
    var title = _a.title;
    return (React.createElement("h4", { className: "color-gray", style: {
            fontSize: 12,
            fontWeight: 'normal',
            padding: '0 24px',
            height: '36px',
            lineHeight: '36px',
            position: 'relative',
            // border: '1px solid #e8ebec',
            background: '#F8F8F8',
            color: '#666666',
        } }, title));
}
//# sourceMappingURL=GroupTitle.js.map